import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from '../config/app-settings';

@Injectable({
  providedIn: 'root'
})
export class SolicitudRegistroService {

  recurso: string = '/solicitud-registro';

 
  constructor(private http: HttpClient) { }

  obtener(uuid: string): Observable<any> {
    return this.http.get(AppSettings.API_URI_PUBLIC + this.recurso + '/obtener/' +uuid);
  }

  obtenerSexo(dominioId: string): Observable<any> {
    return this.http.get(AppSettings.API_URI_PUBLIC + '/dominio?id=' +dominioId);
  }

  solicitar(data: any): Observable<any> {
    return this.http.post(AppSettings.API_URI_PUBLIC + this.recurso + '/solicitar', data);
  }

  confirmar(data: any): Observable<any> {
    return this.http.post(AppSettings.API_URI_PUBLIC + this.recurso + '/validar-usuario', data);
  }

}
